import React, { Component } from "react";

export default class Inicio extends Component {

	render() {

		return (
			<>
				<div className="clearfix" style={{ clear: "both" }}></div>
				<div id="home" className="hero-section">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-md-6">
								<div className="hero-content">
									<div className="hero-title">
										<h1 className="hero-title">Stablecoins</h1>
										<h1 className="hero">made easy</h1>
									</div>
									<div className="hero-text">
										<p>Cirotrx allows users to send stablecoins on the Tron blockchain <br />without requiring TRX or energy in their wallet,<br />providing more accessible and straightforward transactions.</p>
									</div>
									<div className="hero-button">
										<a href="?dapp">Send Stables</a>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="dreamit-hero-thumb">
									<div className="hero-main-thumb">
										<img src="assets/images/slider/tronlink.png" alt="" />
									</div>
									<div className="hero-thumb-inner1 bounce-animate4">
										<img src="assets/images/slider/usdttranslucido.png" alt="" />
									</div>
									<div className="hero-thumb-inner2 bounce-animate">
										<img src="assets/images/slider/usdctranslucido.png" alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="clearfix" style={{ clear: "both" }}></div>


				<div id="stable" className="about-area pt-100 pb-100">
					<div className="container">
						<div className="row">

							<div className="col-lg-6 col-md-6 col-sm-12">
								<div className="dreamit-about-thumb">
									<img src="assets/images/resource/ciroesquema.png" alt="cirotrx" />
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12">
								<div className="dreamit-section-title pb-5">
									<h1>We use <b>most used Stablecoins</b> on <a href="https://tron.network/" target="_blank" rel="noopener noreferrer" style={{ color: 'red' }}>TRON Network</a></h1>
									<p className="section-text">we have tried to include in our system all the most known and used stable currencies.</p>

									<p>our team listens to community requests to add new stables and make the tron network more efficient. </p>
								</div>
								<div className="hero-button">
									<a href="#contact">Contact</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id="contact" className="form-area pt-4 pb-50">
					<div className="container">
						<div className="row">
							<div className="dreamit-section-title text-center up pb-40">

								<h1><span>Contact</span> With Us</h1>
								<p className="section-text">At Cirotrx, powered by Brutus.Finance, your experience matters to us. Whether you have inquiries, feedback, or encounter any issues, our dedicated team is here to assist you. Navigating through the world of decentralized finance should be smooth, and we're here to ensure that your journey with us is seamless.</p>
							</div>
						</div>
						<div className="row text-center ">
							<div className="col-6">

								<div className="contact-icon-box">
									<a target="_blank" rel="noopener noreferrer" href="mailto:admin@cirotrx.com">
										<div className="contact-icon-thumb">
											<img src="assets/images/resource/contact1.png" alt="" />
										</div>
										<div className="contact-text">
											<p>admin@cirotrx.com</p>
										</div>
									</a>

								</div>
							</div>

							<div className="col-6">
								<div className="contact-icon-box">
									<a target="_blank" rel="noopener noreferrer" href="https://t.me/+M02lMfuL6mBlZWI0">
										<div className="contact-icon-thumb">
											<img src="assets/images/resource/contact3.png" alt="" />
										</div>
										<div className="contact-text">
											<p>Join us on Telegram</p>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>


			</>
		);
	}
}
